import React, { useState, useEffect, useContext, useRef } from "react";
import dynamic from "next/dynamic";
import { Store } from "@store";
import Member from "./Member";
import axios from "../../utilities/api/axiosInstance";
import { getAllMembers } from "@queries/community.queries";
import InfiniteScroll from "react-infinite-scroll-component";
import classes from "../../src/socialMediaModule/styles/member.module.css";
import profileClasses from "@styles/profile/profile.module.css";
import LoadingCircle from "@components/loadings/LoadingCircle";
import Heading from "@components/general/Heading";
import { Search as SearchIcon } from "@mui/icons-material";
// import CommunityProfileItem from "@components/general/CommunityProfileItem";
// import CommunityMemberRequests from "./CommunityMemberRequests";
const CommunityMemberRequests = dynamic(() => import("./CommunityMemberRequests"), {
  ssr: false
});
export default function Members({
  communityID,
  isAdmin,
  showHeading = true
}) {
  const {
    state
  } = useContext(Store);
  const loggedInUser = state.user;
  const [isLoading, setIsLoading] = useState(true);
  const [members, setMembers] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [foundMembers, setFoundMembers] = useState(null);
  const [pageNo, setPageNo] = useState(0);
  const [hasMore1, setHasMore1] = useState(true);
  const REF = useRef(null);
  async function getQueryMembers({
    searchInput,
    page
  }) {
    let link;
    if (page) {
      link = `community/member/searchcommunitymember?communityID=${communityID}&query=${searchInput}&page=${page}`;
    } else {
      link = `community/member/searchcommunitymember?communityID=${communityID}&query=${searchInput}`;
    }
    let data = null;
    let error = null;
    const requestOptions = {
      method: "GET",
      url: encodeURI(link)
    };
    const response = await axios(requestOptions).catch(err => {
      error = err;
    });
    if (response?.data?.success) {
      data = response.data?.response;
    }

    // if (response?.data?.success) hashtags = response?.data?.response;
    // else if (response?.data?.message) error = response.data.message;
    return {
      data,
      error
    };
  }
  const updateFoundMemberData = async () => {
    let {
      data,
      error
    } = await getQueryMembers({
      searchInput: searchText,
      page: pageNo + 1
    });
    if (!error && data) {
      setPageNo(cur => cur + 1);
      if (data.length !== 0) {
        setFoundMembers(currentData => currentData.concat(data));
      }
    }
  };
  useEffect(() => {
    setPageNo(0);
    setFoundMembers(null);
    async function getSearchedMembers() {
      let {
        data,
        error
      } = await getQueryMembers({
        searchInput: searchText
      });
      if (data) setFoundMembers(data);
    }
    if (searchText) {
      getSearchedMembers();
    } else {}
  }, [searchText]);
  function setSearch(e) {
    setPageNo(0);
    setFoundMembers(null);
    let input = e.target.value;
    setSearchText(e.target.value);
    setTimeout(async () => {}, 1000);
  }
  useEffect(() => {
    setTimeout(() => {}, 2000);
  }, [foundMembers]);
  useEffect(() => {
    async function getData() {
      const {
        data,
        err
      } = await getAllMembers({
        communityID,
        accessToken: loggedInUser.accessToken
      });
      if (data && !err) {
        setMembers(data);
      }
      setIsLoading(false);
    }
    getData();
  }, [communityID, loggedInUser.accessToken]);
  useEffect(() => {
    if (typeof window !== "undefined" && REF.current && !isLoading) {
      if (REF.current.clientHeight <= window.innerHeight && members.length <= 10) {
        updateMemberData();
      }
    }

    // eslint-disable-next-line
  }, [REF, isLoading]);
  const handleRemove = memberID => {
    setMembers(data => data.filter(item => item.memberID !== memberID));
  };
  const updateMemberData = async () => {
    let joiningTime = null;
    if (members?.length > 0) joiningTime = members[members.length - 1].joiningTime;else return () => {};
    const res = await getAllMembers({
      communityID,
      joiningTime,
      accessToken: loggedInUser.accessToken
    });
    if (res?.data?.length === 0) {
      setHasMore(false);
    } else setMembers(cur => cur.concat(res.data));
  };
  function renderMember(item, index) {
    return <Member key={index.toString()} data={item} isAdmin={isAdmin} handleRemove={handleRemove} data-sentry-element="Member" data-sentry-component="renderMember" data-sentry-source-file="Members.jsx" />;
  }
  if (isLoading) {
    // style={{ textAlign: "center" }}
    return <p className={classes.loadingText}>Loading...</p>;
  }
  if (members?.length > 0) {
    return <div>
        {isAdmin && <CommunityMemberRequests communityID={communityID} setMembers={setMembers} />}

        <div>
          {showHeading ? <Heading headline="Members" /> : <br />}

          <div className={classes.searchContainer}>
            <div className={classes.search_container}>
              <input type="text" placeholder="Search..." onChange={e => {
              setSearchText(e.target.value);
            }} />
              <div className={classes.search_Icon}>
                <SearchIcon />
              </div>
            </div>
          </div>

          {searchText === "" && <div className={classes.members_container} ref={REF}>
              <InfiniteScroll dataLength={members.length} next={updateMemberData} hasMore={hasMore} loader={<LoadingCircle />}>
                {members.map(renderMember)}
              </InfiniteScroll>
            </div>}
          {foundMembers?.length === 0 && <div>
              <p style={{
            textAlign: "center"
          }}>
                <b>No Members Found</b>
              </p>
            </div>}

          {searchText !== "" && foundMembers && <div className={classes.foundMembers_container} ref={REF}>
              <InfiniteScroll dataLength={foundMembers?.length} next={updateFoundMemberData} hasMore={true} loader={<LoadingCircle />}
          // endMessage={
          //   <p style={{textAlign: 'center'}}>
          //     <b>Yay! You have seen it all</b>
          //   </p>
          // }
          scrollableTarget={profileClasses.profile_display_inner_right} endMessage={<p style={{
            textAlign: "center",
            marginTop: "100px",
            zIindex: "100"
          }}>
                    <b>Yay! You have seen it all</b>
                  </p>}>
                {foundMembers.map(renderMember)}
              </InfiniteScroll>
            </div>}
        </div>
      </div>;
  }
  return null;
}

/*
  useEffect(() => {
    async function getRequestData(token) {
      const response = await getMemberRequests({
        communityID: communityID,
        accessToken: loggedInUser.accessToken,
        cancelToken: token,
      });

      if (response) {
        setRequests(response.data);
      } else {
        setRequests([]);
      }
      setIsLoading(false);
    }

    let source = null;
    if (loggedInUser.authType) {
      source = axios.CancelToken.source();
      getRequestData(source.token);
    }

    return () => {
      if (source) source.cancel();
    };
  }, [communityID, loggedInUser]);

  async function updateRequestData() {
    let joiningTime = null;
    if (requests?.length > 0)
      joiningTime = requests[requests.length - 1].joiningTime;
    else return () => {};

    const res = await getMemberRequests({
      communityID: communityID,
      ts: joiningTime,
      accessToken: loggedInUser.accessToken,
    });

    if (res?.data?.length === 0) {
      setHasMore1(false);
    } else setRequests((cur) => cur.concat(res.data));
  }

  function renderRequest(data, index) {
    const approveReq = async (e) => {
      e.preventDefault();
      const res = await approveMemberRequest({
        communityID: data.communityID,
        uid: data.uid,
        accessToken: loggedInUser.accessToken,
      });

      if (res) {
        handleReqChange(data.uid);
      } else {
        alert("Something went wrong!");
      }
    };

    const rejectReq = async (e) => {
      e.preventDefault();
      const res = await rejectMemberRequest({
        communityID: data.communityID,
        uid: data.uid,
        accessToken: loggedInUser.accessToken,
      });

      if (res) {
        handleReqChange(data.uid);
      } else {
        alert("Something went wrong!");
      }
    };

    const handleReqChange = (uid) => {
      setRequests((data) => data.filter((item) => item.uid !== uid));
    };

    const onclickHandler = () => viewProfile(data.uid, router);
    return (
      <div className={`${classes.member}`} key={index.toString()}>
        <div style={{ display: "flex" }}>
          <Avatar
            className={`${classes.profilePic}`}
            alt={data?.User.name?.charAt(0).toUpperCase()}
          >
            <Image
              src={data.User?.dp || defaultProfilePic}
              alt={`${data.User.name} dp`}
              width="60"
              height="60"
              objectFit="cover"
            />
          </Avatar>
          <div className={`${classes.user_info}`}>
            <h5 className={`${classes.username}`} onClick={onclickHandler}>
              {data?.User.name}
            </h5>
          </div>
          <button
            className={classes.btn}
            style={{
              padding: "0 9px",
              marginRight: "8px",
              border: "2px solid grey",
            }}
            onClick={approveReq}
          >
            <CheckIcon />
          </button>
          <button
            className={classes.btn}
            style={{ padding: "0 9px", border: "2px solid grey" }}
            onClick={rejectReq}
          >
            <ClearIcon />
          </button>
        </div>
      </div>
    );
  }

  const RequestModal = () => {
    function closeModal() {
      setShowRequestModal(false);
    }

    const CommunityRequest = () => {
      if (isLoading) {
        return <p style={{ textAlign: "center" }}>Loading...</p>;
      } else {
        if (requests.length > 0) {
          return (
            <div>
              <InfiniteScroll
                dataLength={requests.length}
                next={updateRequestData}
                hasMore={hasMore1}
                loader={<LoadingCircle />}
              >
                {requests.map(renderRequest)}
              </InfiniteScroll>
            </div>
          );
        } else return <>Requests</>;
      }
    };

    return (
      <Modal open={showRequestModal}>
        <div className={`${classes.requestModal_overlay}`}>
          <div className={`${classes.requestModal}`}>
            <form className={`${classes.joinReq_form}`}>
              <header className={`${classes.joinReq_header}`}>
                <div className={`${classes.joinReq_header_head}`}>
                  Join Requests
                </div>
                <CancelIcon
                  className={`${classes.joinReq_closebtn}`}
                  onClick={closeModal}
                />
              </header>
              <CommunityRequest />
            </form>
          </div>
        </div>
      </Modal>
    );
  };
*/